export const facebook = "https://www.facebook.com/sliitfoss";
export const twitter = "https://twitter.com/fosssliit";
export const instagram = "https://www.instagram.com/sliitfoss/";
export const linkedIn = "https://www.linkedin.com/company/sliit-foss-community";
export const youTube = "https://youtube.com/@SLIITFOSSCommunity";
export const github = "https://github.com/sliit-foss";
export const tikTok = "https://www.tiktok.com/@sliit.foss?_t=ZS-901S3aoXg4O&_r=1";
